import { useState } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw, ContentState } from "draft-js";
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import './../../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
const ControllerEditor = (props) => {
    const {content = '<p style="text-align:center;"><strong>Hola escribe a qui tu texto</strong></p>', onValue, height="400px"} = props
    const blocksFromHtml = htmlToDraft(content);
    const { contentBlocks, entityMap } = blocksFromHtml;
    const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
    const [editorState, setEditorState] = useState(EditorState.createWithContent(contentState)) 
    const changeEditor = (EditorState) => {
        onValue(draftToHtml(convertToRaw(EditorState.getCurrentContent())))
        setEditorState(EditorState)
    }

    return (
        <div>
            <Editor
                editorState={editorState}
                toolbarClassName="demo-toolbar-custom"
                wrapperClassName="demo-wrapper"
                editorClassName="demo-editor-custom"
                toolbarStyle={{
                    border: "1px solid #009bdb",
                }}
                editorStyle={{
                    minHeight:height,
                    maxHeight:height,
                    overflowY: "scroll",
                    border: "1px solid #009bdb",
                    padding: "0px 5px"
                }}
                onEditorStateChange={changeEditor}
            />
        </div>
    )
}
export default ControllerEditor